import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InversionistasService } from '../../services/inversionistas.service';
import { HelpersService } from '../../services/tools/helpers.service';

@Component({
  selector: 'app-inversionista-detalles',
  templateUrl: './inversionista-detalles.component.html',
  styleUrls: ['./inversionista-detalles.component.scss']
})
export class InversionistaDetallesComponent implements OnInit {
  pagareSeleccionado: any = null;
  seccionActiva: string = 'datosGenerales';
  public idInversionista: number;
  public inversionista: any = { pagares: [] };
  public loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private inversionistasService: InversionistasService,
    private helperService: HelpersService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idInversionista = +params['id'];
      if (this.idInversionista) {
        this.getDetalleInversionista(this.idInversionista);
      }
    });
  }

  public getDetalleInversionista(id: number) {
    this.loading = true;
    this.inversionistasService.obtenerInversionistaPorId(id)
      .subscribe(response => {
        const result = response.json();
        if (result.success) {
          this.inversionista = result.content;

          if (!this.inversionista.pagares) {
            this.inversionista.pagares = [];
          }

          console.log("Detalle cargado: ", this.inversionista);
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        this.helperService.httpGlobalError(error);
      });
  }

  // Uso del servicio en lugar de HttpClient directo
  // public verDetallePagare(id: number) {
  //   this.inversionistasService.obtenerDetallePagare(id).subscribe(response => {
  //     const result = (response as any).json ? (response as any).json() : response;
  //     if (result.success) {
  //       this.pagareSeleccionado = result.content;
  //       this.seccionActiva = 'detallePagare'; // Cambia la vista para mostrar el resumen del pagaré
  //     }
  //   }, error => {
  //     this.helperService.httpGlobalError(error);
  //   });
  // }

  public verDetallePagare(id: number) {
    // Reemplaza '/pagare/detalles' con la ruta exacta que hayas definido en tus rutas de Angular
    this.router.navigate(['/inversiones/pagare/detalles', id]);
  }

  public irAEdicion() {
    this.router.navigate(['/inversionistas/registro/', this.idInversionista]);
  }

  public volver() {
    this.router.navigate(['/inversionistas']);
  }
}


// WEBPACK FOOTER //
// ./src/app/inversiones/detalles/inversionista-detalles.component.ts